// extracted by mini-css-extract-plugin
export var animating = "_19-3";
export var background = "_19-6";
export var constrainHeight = "_19-2";
export var dark = "_19-4";
export var dropdown = "_19-1";
export var leave = "_19-5";
export var option = "_19-7";
export var root = "_19-0";